<div [lang]="dictionaryService.language" [dir]="dictionaryService.language == 'ar' ? 'rtl' : 'ltr'"
  class="app-container">
  <!-- Only show navbar and loading screen if not on login route -->
  @if(getRoute() !== '/login')
  {
    <ng-container>
      <app-navbar></app-navbar>
      <app-loading-screen></app-loading-screen>
    </ng-container>
  }
  <div [ngClass]="{ container: getRoute() !== '/login' }">
    <router-outlet></router-outlet>
  </div>

  <!-- Global Snackbar Component -->
  <app-snackbar></app-snackbar>
</div>